// Detección centralizada del "token caducado" (402) que devuelven los WS SOAP.
//
// El backend responde HTTP 200 con el código dentro del payload, y según el WS
// llega en un campo u otro:
//   - XML:  <returnValue>402</returnValue>, <CodigoRetorno>402</CodigoRetorno>
//   - JSON embebido en el XML: "returnValue":402, "sReturnNumber":"402"
//     (a veces con las comillas escapadas como &quot;)
//
// `sReturnNumber` es el nº de mensaje SAP en errores y el nº de recogida en
// éxitos, así que sólo cuenta como 402 si la operación no ha ido bien
// (returnValue distinto de 0).

const QUOTE = '(?:"|&quot;)?';
const fieldRegex = (field, code) =>
  new RegExp(`${field}(?:>|${QUOTE}\\s*:\\s*${QUOTE})\\s*${code}(?!\\d)`);

const AUTH_CODE_RE = fieldRegex("(?:returnValue|CodigoRetorno)", 402);
const RETURN_NUMBER_RE = fieldRegex("sReturnNumber", 402);
const RETURN_VALUE_OK_RE = fieldRegex("returnValue", 0);

export class SessionExpiredError extends Error {
  constructor(cause) {
    super("Sesión expirada", { cause });
    this.name = "SessionExpiredError";
  }
}

export function isSessionExpiredError(error) {
  return error instanceof SessionExpiredError;
}

export function isAuthExpiredPayload(data) {
  if (data == null) return false;
  const text = typeof data === "string" ? data : JSON.stringify(data);
  // Pre-filtro barato: la inmensa mayoría de respuestas no contienen "402".
  if (!text || !text.includes("402")) return false;
  if (AUTH_CODE_RE.test(text)) return true;
  return RETURN_NUMBER_RE.test(text) && !RETURN_VALUE_OK_RE.test(text);
}
